import { combineReducers } from 'redux';

import { ACTIONS as addHealthCheckData } from '@~/actions/add-health-check-data';
import { ACTIONS as classroomStudents } from '@~/actions/classroom-students';
import { ACTIONS as classroomActions } from '@~/actions/classrooms';
import { ACTIONS as configActions } from '@~/actions/configs';
import { ACTIONS as demoFeedbackActions } from '@~/actions/demo-feedback';
import { ACTIONS as gatekeeperActions } from '@~/actions/gatekeeper';
import { ACTIONS as logoutActions } from '@~/actions/logout';
import { ACTIONS as logoutEverywhereActions } from '@~/actions/logout-everywhere';
import { ACTIONS as masteryPlanActions } from '@~/actions/mastery-plan';
import { ACTIONS as monthlyProgressV2 } from '@~/actions/monthly-progress-v2';
import { ACTIONS as parentOTP } from '@~/actions/parent-otp';
import { ACTIONS as ptmActions } from '@~/actions/ptm';
import { ACTIONS as ptmFeedbackActions } from '@~/actions/ptm-feedback';
import { ACTIONS as ptmScheduledDate } from '@~/actions/ptm-schedule-actions';
import { ACTIONS as studentNodeAction } from '@~/actions/student-node';
import { ACTIONS as teacherActions } from '@~/actions/teacher';
import { ACTIONS as teacherBadgesActions } from '@~/actions/teacher-badges';
import { ACTIONS as vibeActions } from '@~/actions/vibe';
import { ACTIONS as worksheetAttemptsActions } from '@~/actions/worksheet-attempts';

import appConfigReducer from './app-config';
import authReducer from './auth';
import avSessionTokenReducer from './av-session-token';
import awsSignedKeyReducer from './aws-signed-key';
import chatEventsReducer from './chat-events';
import chatSoundReducer from './chat-sound';
import chatWindowReducer from './chat-window';
import classStatusReducer from './class-status';
import clientEventReducer from './client-notification';
import completionCeremonyReducer from './completion-ceremony';
import CueBoardReducer from './cue-board';
import curriculumHomeReducer from './curriculum-home-details';
import DemoReportReducer from './demo-report';
import DisableGroupChatReducer from './disable-group-chat';
import EnableGroupChatReducer from './enable-group-chat';
import eventNotificationReducer from './event-notification';
import eventsTrackerReducer from './events-tracker';
import abTestingReducer from './ab-testing';
import feelCheckReducer from './feel-check';
import homeDetailsReducer from './home-details';
import leaderboardReducer from './leaderboard';
import liveClassConfigReducer from './live-class-config';
import maintenanceReducer from './maintenance';
import NotificationReducer from './notification';
import notificationHomeReducer from './notification-home';
import notificationHomeDataReducer from './notification-home-data';
import ParentProfileReducer from './parent-profile';
import PerfectHitReducerV2 from './perfect-hit';
import planetUIReducer from './planet-ui';
import programsReducer from './programs';
import ptmSlideEventActions from './ptm-screens';
import receiveClassChatMessageReducer from './receive-class-chat-message';
import receiveTeacherChatMessageReducer from './receive-teacher-chat-message';
import receiveTeacherReadChatMessageReducer from './receive-teacher-read-chat-message';
import RestReducer from './reducer';
import rewardsHomeReducer from './rewards-home';
import sendClassChatMessageReducer from './send-class-chat-message';
import sendTeacherChatMessageReducer from './send-teacher-chat-message';
import sendTeacherReadChatMessageReducer from './send-teacher-read-chat-message';
import sideModalReducer from './side-modal';
import SnackbarReducer from './snackbar';
import spStateReducer from './sp-state-reducer';
import statusReducer from './status';
import studentAlertsReducer from './student-alerts';
import studentEventsReducer from './student-events';
import studentsReducer from './students';
import TalkMeterReducer from './talk-meter';
import TeacherControlReducer from './teacher-control';
import toastReducer from './toast-msg';
import TrialHomeReducer from './trial-home-reducer';

export default combineReducers({
  auth: authReducer,
  appConfig: appConfigReducer,
  avSessionToken: avSessionTokenReducer,
  awsSignedKey: awsSignedKeyReducer,
  chatSound: chatSoundReducer,
  chatWindow: chatWindowReducer,
  classStatus: classStatusReducer,
  classrooms: RestReducer(classroomActions),
  classroomStudents: RestReducer(classroomStudents),
  clientEvent: clientEventReducer,
  completionCeremony: completionCeremonyReducer,
  configs: RestReducer(configActions),
  cueBoard: CueBoardReducer,
  perfectHits: PerfectHitReducerV2,
  curriculumHome: curriculumHomeReducer,
  demoFeedback: RestReducer(demoFeedbackActions),
  demoReport: DemoReportReducer,
  disableGroupChat: DisableGroupChatReducer,
  enableGroupChat: EnableGroupChatReducer,
  eventNotification: eventNotificationReducer,
  eventsTracker: eventsTrackerReducer,
  abTesting: abTestingReducer,
  feelCheck: feelCheckReducer,
  liveClassConfig: liveClassConfigReducer,
  gatekeeper: RestReducer(gatekeeperActions),
  healthCheckData: RestReducer(addHealthCheckData),
  homeDetails: homeDetailsReducer,
  leaderBoard: leaderboardReducer,
  logout: RestReducer(logoutActions),
  logoutEverywhere: RestReducer(logoutEverywhereActions),
  maintenance: maintenanceReducer,
  sideModal: sideModalReducer,
  monthlyProgressV2: RestReducer(monthlyProgressV2),
  notification: NotificationReducer,
  notificationHome: notificationHomeReducer,
  notificationHomeData: notificationHomeDataReducer,
  openChatWindow: chatEventsReducer,
  parentOTP: RestReducer(parentOTP),
  parentProfileInfo: ParentProfileReducer,
  planetUI: planetUIReducer,
  programs: programsReducer,
  ptmSlideEvent: ptmSlideEventActions,
  ptmSlide: RestReducer(ptmActions),
  ptmScheduledDate: RestReducer(ptmScheduledDate),
  ptmFeedback: RestReducer(ptmFeedbackActions),
  receiveClassChatMessage: receiveClassChatMessageReducer,
  receiveTeacherChatMessage: receiveTeacherChatMessageReducer,
  receiveTeacherReadChatMessage: receiveTeacherReadChatMessageReducer,
  rewards: rewardsHomeReducer,
  sendClassChatMessage: sendClassChatMessageReducer,
  sendTeacherChatMessage: sendTeacherChatMessageReducer,
  sendTeacherReadChatMessage: sendTeacherReadChatMessageReducer,
  snackbar: SnackbarReducer,
  status: statusReducer,
  student: studentsReducer,
  studentAlerts: studentAlertsReducer,
  studentEvents: studentEventsReducer,
  studentNode: RestReducer(studentNodeAction),
  talkMeter: TalkMeterReducer,
  teacher: RestReducer(teacherActions),
  teacherBadges: RestReducer(teacherBadgesActions),
  teacherControl: TeacherControlReducer,
  toastMessage: toastReducer,
  vibe: RestReducer(vibeActions),
  worksheetAttempts: RestReducer(worksheetAttemptsActions),
  masteryPlan: RestReducer(masteryPlanActions),
  spState: spStateReducer,
  trialHome: TrialHomeReducer,
});
